/** "You're offline" while the browser has no network (BR-136): said at once, instead of a skeleton that waits. */
import { useSyncExternalStore } from "react";

function subscribe(fn: () => void): () => void {
  window.addEventListener("online", fn);
  window.addEventListener("offline", fn);
  return () => {
    window.removeEventListener("online", fn);
    window.removeEventListener("offline", fn);
  };
}

/** The browser's own idea of being online (`navigator.onLine` and its events). */
export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}

export function OfflineBanner() {
  const online = useOnline();
  return (
    // the live region is always there, so screen readers announce the change
    <div role="status" aria-live="polite" className="offline-slot">
      {!online && (
        <p className="offline-banner" data-testid="offline-banner">
          <b>You&apos;re offline.</b> Bason shows what it has; new data loads when you&apos;re back online.
        </p>
      )}
    </div>
  );
}
